import { getQueryValue } from "../../utils/url";
import { fetchBrandAndSetJigsawHost } from "./brand-utils";
import { BrandData } from "../brand-context/BrandData";
import { useEffect, useMemo, useState } from "react";

type Messages = Record<string, string>;

export enum LoadStatus {
  LOADING,
  OK,
  ERROR,
}

interface InitData {
  status: LoadStatus;
  data?: {
    messages: Messages;
    brandData: BrandData;
    locale: string;
  };
}

const locale = "en";

export function useInit(): InitData {
  const [brandData, setBrandData] = useState<undefined | BrandData>();
  const [messages, setMessages] = useState<undefined | Messages>();
  const [status, setStatus] = useState(LoadStatus.LOADING);
  const value = useMemo(() => {
    if (messages && brandData) {
      return { status, data: { messages, brandData, locale } };
    }
    return { status };
  }, [messages, brandData, status]);

  useEffect(() => {
    if (window.jigsawLoadError) {
      setStatus(LoadStatus.ERROR);
    } else {
      const brandId = getQueryValue("brand") || window.location.hostname;
      fetchBrandAndSetJigsawHost(brandId as string)
        .then(setBrandData)
        // TODO: Lang will eventually come from brand
        .then(() => import(`locale/${locale}.json`))
        .then(setMessages)
        .then(() => setStatus(LoadStatus.OK))
        .catch(() => setStatus(LoadStatus.ERROR));
    }
  }, []);

  return value;
}
